import React, { useEffect } from "react";
import { useStore } from "@/context/StoreContext";

const SearchPage = () => {
  const { setSearchOpen } = useStore();
  useEffect(() => { setSearchOpen(true); }, [setSearchOpen]);
  return <div className="min-h-[60vh]" />;
};

export default SearchPage;
